export const KEYKLOACK_URL = {
	STAGING: "https://keycloak-staging.ntsal.dev/auth/",
	PRODUCTION: "https://contact-form.ntsal.dev/auth/"
};
export const APIs_URL = {
	STAGING: "http://localhost:8009",
	PRODUCTION: "https://contact-form.ntsal.dev/api"
};